import { Reducer } from "redux";
import IMessageState from "./IMessagesState";
import { MessagesAction, MessagesActionTypes } from "./MessagesActions";

const initialState: IMessageState = {
  messages: { result: [], count: 0, unreadedCount: 0 },
};

const MessagesReducer: Reducer<IMessageState, MessagesAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case MessagesActionTypes.SET_MESSAGES:
      return {
        ...state,
        messages: action.data,
      };
    default:
      return state;
  }
};

export default MessagesReducer;
